import React, { useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Header from "../../components/Header";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Sidebar from "../../components/Sidebar";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import Form from "react-bootstrap/Form";
import "react-datepicker/dist/react-datepicker.css";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { BASE_URL, REGISTER_TEST } from "../../API";
import axios from "axios";
import Loader from "../../components/Loader";
import { ProfileContext } from "../../context/ProfileContext";
import { diagnosticCategories } from "../../utils/helper";

function AddDiagnosticTest() {
  const navigate = useNavigate();
  const { headers, getTests } = useContext(ProfileContext)
  const { register, handleSubmit, formState: { errors }, reset } = useForm();

  const [isLoading, setIsLoading] = useState(false);

  const onSubmit = async (data) => {

    setIsLoading(true);
    try {
      const response = await axios.post(BASE_URL + REGISTER_TEST, data, { headers });
      if (response.data.code === 200 && response.data.status === true) {
        toast.success(response.data.message);
        reset();
        getTests();
        navigate('/diagnostic-test-management')
      }
    }
    catch (error) {
      if (error.response && error.response.data) {
        const errorMessage = error.response.data.error || "An error occurred";
        toast.error(errorMessage);
      }
      else { toast.error("An error occurred") }
    }
    finally { setIsLoading(false) }
  }

  return (
    <>
      <Loader isLoading={isLoading} />
      <div className="container-fluid">
        <Header />
        <div className="row">
          <Sidebar />
          <div className="col-9 main-dash-left">
            <section className="back-dashboard-sec comn-dashboard-page">
              <div className="cstm_bredcrumb_outer">
                <Breadcrumb className="cstm_bredcrumb" listProps={{ className: "breadcrumb-custom-separator" }}>
                  <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/diagnostic-center-management" }}>Diagnostic Test Management</Breadcrumb.Item>
                  <Breadcrumb.Item active >Add Test</Breadcrumb.Item>
                </Breadcrumb>
              </div>
              <div className="notifi-list d-flex"><h6 className="comm_page_heading">Add Diagnosis Test</h6></div>

              <div className="patient_referral_form">
                <div className="comm_border_box">
                  <Form className="comm_form" onSubmit={handleSubmit(onSubmit)}>
                    <Row>
                      <Col md={6}>
                        <Form.Group className="comn-class-inputs">
                          <Form.Label>Test Name</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Enter Name"
                            {...register("test_name", {
                              required: 'Please enter test name.',
                              validate: value => value.trim() !== "" || "Name cannot be Empty or just spaces.",
                            })}
                          />
                          {errors.test_name && <span className="error">{errors.test_name.message}</span>}
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group className="comn-class-inputs">
                          <Form.Label>Category</Form.Label>
                          <Form.Select {...register("category", { required: "Please select category." })}>
                            <option value="">Select </option>
                            {diagnosticCategories.map((cate, index) => (<option key={index} value={cate.value}>{cate.label}</option>))}
                          </Form.Select>
                          {errors.category && (<span className="error">{errors.category.message}</span>)}
                        </Form.Group>
                      </Col>
                    </Row>
                    <div className="modal_pair_btns patient_referral_btns ">
                      <button type="submit" className='main-btn' >Submit</button>
                      <button className='main-outline-btn' onClick={() => { navigate('/diagnostic-test-management') }}>Discard Changes</button>
                    </div>
                  </Form>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </>
  );
}

export default AddDiagnosticTest;
